/**
 * **Where each record lives, when several locations are on screen**.
 *
 * A screen that shows two locations at once reads each location's list with that
 * location's header and merges them. A record read at one location must then be
 * changed at that location, whichever location the person is signed in at, so every
 * id read that way is remembered here with its location, and `api()` sends a call
 * whose path names one of those ids to that location. The server still checks the
 * person may act there.
 */
const homes = new Map<string, string>();

export function locate(id: string, branchId: string): void {
  homes.set(id, branchId);
}

/** The location a call belongs to, from the first remembered id in its path. */
export function locatedBranch(path: string): string | null {
  if (homes.size === 0) return null;
  for (const part of path.split(/[/?&=]/)) {
    const home = homes.get(part);
    if (home !== undefined) return home;
  }
  return null;
}
